import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { EntityContext, EntitySelectedContextValue } from "./EntityContext";

export const useEntitySelectedProvider = () => {
  const context = useContext(EntityContext);

  if (!context) {
    throw new HookOutOfContextError("useEntityProvider", "EntityContext");
  }

  if (!context.entityId || !context.entity || !context.subscriptionInfo) {
    throw new Error(
      "useEntitySelectedProvider should be used only when user has selected entity"
    );
  }

  return context as EntitySelectedContextValue;
};
